import * as React from "preact";
import { FunctionComponent, TargetedEvent } from "preact";

import { IFilter } from "../Table";

interface IFilterComponent {
  filter: IFilter;
  handleFilter: (e: TargetedEvent<HTMLSelectElement, Event>) => void;
  defaultFilter: string;
}

const TableFilter: FunctionComponent<IFilterComponent> = ({ filter, handleFilter, defaultFilter }) => {
  return (
    <div>
      <label>
        <strong>{filter.filterLabel}</strong>
      </label>
      <select
        id={filter.filterField}
        onChange={handleFilter}
      >
        {filter.filterProperties.map((item) => (
          <option
            selected={defaultFilter ? item.filterDisplay.toLowerCase() == defaultFilter.toLowerCase() : undefined}
            value={item.fieldsToShow}
            key={item.fieldsToShow}
          >
            {item.filterDisplay}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TableFilter;
